

export class Plyr{
    constructor(){
    }

    static async renderPlayer(el, attrs = {}){
        const {default : Plyr} = await import ('plyr')
        const player = new Plyr(el, {
            enabled: true,
            ...attrs
        })
    }
}